import styled from 'styled-components';
import BaseClockIcon from '#/shared/components/GeneratedIcons/trimet/TransitTrackerSolid';
import { Z_INDEX_TOP } from '#/shared/constants';
import BaseTimePartInput from './TimePartInput';

export const TimePickerContainer = styled.div`
  width: 150px;
`;

export const TimeFieldContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${props =>
    props.popperVisible ? props.theme.dropDownInputBg : 'transparent'};
  box-shadow: ${props =>
    props.popperVisible ? props.theme.dropDownInputShadow : 'none'};
  border-radius: ${props => props.theme.dropDownInputRadius};
  width: 100%;
`;

export const TimeInputGroupContainer = styled.div`
  display: flex;
  white-space: pre;
`;

export const TimePartInput = styled(BaseTimePartInput)`
  appearance: textfield;
  background-color: transparent;
  border: none;
  caret-color: transparent;
  color: inherit;
  display: flex;
  font-family: inherit;
  font-size: inherit;
  text-align: center;
  padding: 0 1px;

  &:focus,
  &:active {
    background-color: ${({ theme }) => theme.dropDownTimeInputFocus};
    border-radius: none;
  }
`;

export const ClockIcon = styled(BaseClockIcon)`
  height: 1em;
  width: 1em;
`;

// PopperWrapper is needed to allow PopperContainer to be both
// absolutely positioned and have its width match the input element's
export const PopperWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const PopperContainer = styled.div`
  position: absolute;
  border-radius: ${props => props.theme.dropDownContentRadius};
  border: 1px solid ${props => props.theme.dropDownBorder};
  box-shadow: ${props =>
    props.popperVisible && props.theme.dropDownContentShadow};
  left: 50%;
  transform: translate(-50%, -3px);
  min-width: 100%;
  background-color: ${props => props.theme.dropDownContentBg};
  z-index: ${Z_INDEX_TOP};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ColumnContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 10em;
  overflow-y: hidden;
  padding: 5px 0;
`;

export const SelectionColumn = styled.div.attrs({
  // this element is incorrectly gaining focus when tabbing in Firefox due to
  // a bug in that browser, this setting is a workaround to remove it from
  // the focus flow: https://bugzilla.mozilla.org/show_bug.cgi?id=1069739
  tabIndex: -1,
})`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;

  /* top padding is to leave for focus outline when the column is scrolled to
  the top */
  padding: 3px 12px;

  /* in order leave room for the focus outline when scroll snapping this value
  should to equate to the top padding of this container plus the top margin of
  the column item */
  scroll-padding-top: 5px;

  -ms-overflow-style: none; /* hide scrollbar for IE and Edge */
  scrollbar-width: none; /* hide scrollbar for Firefox */

  /* hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  &:focus {
    outline: none;
  }
`;

export const SelectionColumnItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 2px 0;
  height: 2.25em;
  width: 2.25em;
  font-size: 0.8em;
  border-radius: 50%;
  background-color: transparent;
  color: ${({ theme }) => theme.dropDownText};
  scroll-snap-align: start;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.dropDownOptionSelectedHover};
  }

  &[aria-selected='true'] {
    background-color: ${({ theme }) => theme.dropDownOptionSelected};
    color: ${props => props.theme.dropDownTextSelected};
  }
`;
